import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Avatar, Typography } from "antd";
import moment from "moment";
import * as URLs from "../../../../common/constants/systemUrls";
import { interfaceActions } from "../../../../common/redux/actions";
import * as profilesActions from "../../redux/actions/profiles";
import ProfilesComponent from "../../components/Profiles/Profiles";
import { IMAGE_SERVER } from "../../../../common/constants/systemUrls";
import Employee from '../../../../common/images/svg/Employee.svg';

const { Text } = Typography;
const { setCaption } = interfaceActions;

let { getEmployees, getEmployeesSearch } = profilesActions;

class Profiles extends Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    searchText: null, // для фильтра поиска, пока не используется
    paginationPageSize: 10,
    typeProfiles: "active",
    filterEmployeesRole: "all"
  };

  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      mainCaption: "Сотрудники",
      breadCrumbs: [
        { path: "/" + URLs.CONTROL_PANEL, breadcrumbName: "Панель управления" },
        { path: "/" + URLs.EMPLOYEES, breadcrumbName: "Сотрудники" }
      ]
    });
    this.props.getEmployees();
  }

  renderColumnsTable = () => {
    let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    let columns = [
      {
        title: "",
        dataIndex: "photo",
        key: "photo",
        width: 65,
        render: (photo, record) => (
          <Avatar
            shape="square"
            size="large"
            src={
              photo &&
              (record.roleKey !== "driver" ||
                (record.roleKey === "driver" &&
                  record.profileStatusKey === "active"))
                ? `${IMAGE_SERVER}${photo}`
                : Employee
            }
            icon="user"
          />
        )
      },
      {
        title: "ФИО",
        key: "fio",
        render: (fio, record) => {
          return (
            <div>
              <Text>{record.lastname || record.phoneMask}</Text>
              <br />
              <Text type="secondary">
                {record.name || ""} {record.patronymic ? record.patronymic : "-"}
              </Text>
            </div>
          );
        },
        onFilter: (value, record) =>
          record.name.indexOf(this.state.searchText) === 0,
        sorter: (a, b) => {
          return a.name.localeCompare(b.name);
        },
        sortOrder: sortedInfo.columnKey === "fio" && sortedInfo.order
      },
      {
        title: "Должность",
        dataIndex: "role",
        key: "role",
        render: (role, record) => <span>{role}</span>,
        filteredValue: filteredInfo.work || filteredInfo.position_key || null
        /*
                onFilter: (value, record) => {
                    return record.work.place_work.includes(value) || record.work.position_key.includes(value)
                },
                sorter: (a, b) => {return a.work.position.localeCompare(b.work.position)},
                sortOrder: sortedInfo.columnKey === 'work' && sortedInfo.order
                */
      },
      {
        title: "Дата изменения",
        dataIndex: "updatedAt",
        key: "updatedAt",
        render: updatedAt => (
          <span>
            {moment(updatedAt).format("DD.MM.YYYY")}&nbsp;&nbsp;
            {moment(updatedAt).format("HH:mm")}
          </span>
        ),
        sorter: (a, b) => {
          return a.updatedAt.localeCompare(b.updatedAt);
        },
        sortOrder: sortedInfo.columnKey === "updatedAt" && sortedInfo.order
      }
    ];

    if (this.state.typeProfiles === "archive") {
      columns = columns.concat([
        {
          title: "Дата архивирования",
          dataIndex: "updatedAt",
          key: "archive",
          render: (updatedAt, record) => (
            <Fragment>
              <div>
                {moment(updatedAt).format("DD.MM.YYYY")}&nbsp;&nbsp;
                {moment(updatedAt).format("HH:mm")}
              </div>
              <div>{record.profileStatus ? record.profileStatus : ""}</div>
            </Fragment>
          ),
          sorter: (a, b) => {
            if (a.updatedAt && !b.updatedAt) return 1;
            return a.updatedAt && b.updatedAt
              ? a.updatedAt.localeCompare(b.updatedAt)
              : -1;
          },
          sortOrder: sortedInfo.columnKey === "archive" && sortedInfo.order,
          width: "280px"
        }
      ]);
    } else {
      columns = columns.concat([
        {
          title: "Последний вход",
          dataIndex: "lastActivity",
          key: "lastActivity",
          render: (lastActivity, record) => {
            if (record.profileStatusKey !== "active") {
              return record.profileStatus;
            }
            return lastActivity ? moment(lastActivity).fromNow() : "";
          },
          sorter: (a, b) => {
            if (a.lastActivity && !b.lastActivity) return 1;
            return a.lastActivity && b.lastActivity
              ? a.lastActivity.localeCompare(b.lastActivity)
              : -1;
          },
          sortOrder: sortedInfo.columnKey === "lastActivity" && sortedInfo.order
        }
      ]);
    }
    return columns;
  };

  // Выбор кол-во отображаемых элементов в таблице
  handleChangePagination = e => {
    this.setState((state, props) => ({
      paginationPageSize: parseInt(e)
    }));
  };

  handleClickRow = id => {
    this.props.history.push(`/${URLs.EMPLOYEES}/${id}`);
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };

  handleTypesEmployees = e => {
    this.setState((state, props) => {
      const { searchProfiles } = props;
      if (searchProfiles && searchProfiles.searchValue) {
        this.props.getEmployeesSearch({
          typeProfiles: e.target.value,
          search: searchProfiles.searchValue
        });
      }
      return {
        filteredInfo: null,
        typeProfiles: e.target.value,
        filterEmployeesRole: "all"
      };
    });
  };

  handleFilterEmployeesRole = e => {
    this.setState((state, props) => ({
      filteredInfo: null,
      filterEmployeesRole: e.target.value
    }));
  };

  handleSearch = e => {
    let val = e.target.value.trim();
    this.props.getEmployeesSearch({
      typeProfiles: this.state.typeProfiles,
      search: val
    });
  };

  getProfiles() {
    const { profiles, searchProfiles } = this.props;
    const { typeProfiles, filterEmployeesRole } = this.state;
    let employees = null;
    if (searchProfiles && searchProfiles.searchValue) {
      employees = searchProfiles.search;
    } else {
      if (profiles && profiles[typeProfiles]) {
        employees = profiles[typeProfiles];
      }
    }
    if (filterEmployeesRole !== "all") {
      return employees.filter(item => item.roleKey === filterEmployeesRole);
    }
    return employees;
  }

  getStat() {
    const { profiles, searchProfiles } = this.props;
    if (searchProfiles && searchProfiles.searchValue) {
      return searchProfiles && searchProfiles.stat;
    } else {
      return (
        profiles && profiles.stat && profiles.stat[this.state.typeProfiles]
      );
    }
  }

  render() {
    const { profiles, searchProfiles } = this.props;
    const { typeProfiles } = this.state;

    return (
      <ProfilesComponent
        {...this.props}
        {...this.state}
        typeProfiles={typeProfiles}
        profiles={this.getProfiles()}
        countActiveProfiles={
          (profiles && profiles.stat && profiles.stat.active.all) || 0
        }
        countArchiveProfiles={
          (profiles && profiles.stat && profiles.stat.archive.all) || 0
        }
        countProfilesPosition={this.getStat()}
        positionsProfiles={profiles && profiles.roles}
        rowKey="profileId"
        renderColumnsTable={this.renderColumnsTable}
        handleChange={this.handleChange}
        handleChangePagination={this.handleChangePagination}
        handleClickRow={this.handleClickRow}
        handleTypesEmployees={this.handleTypesEmployees}
        handleFilterEmployeesRole={this.handleFilterEmployeesRole}
        handleSearch={this.handleSearch}
        searchValue={searchProfiles && searchProfiles.searchValue}
      />
    );
  }
}

export default connect(
  state => ({
    // CRUD data
    profiles: state.Employees.profiles.data,
    // Filter fields data
    searchProfiles: state.Employees.profiles.dataSearch,
    // UI data
    isLoading: state.Employees.profiles.isLoading
  }),
  {
    // CRUD METHODS
    getEmployees,

    // GET FILTER FIELDS METHODS
    getEmployeesSearch,
    // UI METHODS
    setCaption
  }
)(Profiles);
